'use client';

import useStore from '@/stores/useStore';
import { FC } from 'react';

export interface TextMediaProps {
  title: React.ReactNode;
  alternateFeatures: boolean;
  features: {
    title: string;
    featureImage: React.ReactNode;
    bullets: {
      feature: string;
    }[]
  }[]
}

const TextMedia: FC<TextMediaProps> = ({
  title,
  alternateFeatures = false,
  features = []
}) => {
  const { setDemoModalOpen, setTrialModalOpen } = useStore();

  const onClickMenuButton = (action) => {
    switch (action) {
      case 'trial':
        setTrialModalOpen(true);
        break;
      case 'demo':
        setDemoModalOpen(true);
        break;

      default:
        break;
    }
  };

  return (
    <div className="bg-violet-100 text-white">
      <div className="-mt-header-height-mobile md:-mt-header-height-desktop pt-0 md:pt-header-height-desktop">
        <div className="pt-[48px] md:pt-12 px-container-mobile md:px-container-desktop pb-0 md:pb-10">
          <div className="grid gap-2 md:gap-3 text-left mx-auto max-w-grid">
            <div className="flex justify-center">
              <h2 className="text-blue-900 text-25/30 md:text-43/53 font-500 text-center mb-[34px] md:mb-[64px]">{title}</h2>
            </div>
            {features.map((item, index) => {
              return (
                <div
                  key={`feature-${index}`}
                  className={`flex flex-wrap md:flex-nowrap justify-between items-center mb-[60px] md:mb-[108px] flex-col-reverse ${
                    (alternateFeatures && (index % 2 === 1)) ? 'md:flex-row-reverse' : 'md:flex-row'
                  }`}
                >
                  <div className="flex flex-wrap items-start max-w-[505px] w-full md:w-1/2">
                    <h4 className="text-blue-900 font-500 text-21/28 md:text-30/38 mb-[48px]">{item.title}</h4>
                    <div className="flex flex-wrap">
                      {item.bullets.map((bullet, index) => {
                        return (
                          <div key={`bullet-${index}`} className="flex w-full mb-[30px]">
                            <div
                              className="flex w-[24px] h-[24px] bg-blue-900 rounded-[50%] justify-center items-center mr-[16px] px-[4px] py-[8px]">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                   fill="none">
                                <path d="M11.6673 3.5L5.25065 9.91667L2.33398 7" stroke="white" strokeWidth="1.5"
                                      strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </div>
                            <div className="flex text-blue-900 text-17/25">
                              {bullet.feature}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div className="flex justify-center mb-[24px] md:mb-0 w-full md:w-1/2">
                    {item.featureImage}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextMedia;
